<template>
  <span class="brand-mark" :style="sizeStyle" aria-hidden="true">
    <svg :width="logoWidth" :height="logoHeight" viewBox="0 0 100 67" fill="none" stroke="currentColor"
      stroke-width="8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M11 55L27 23L50 64L64 35" />
      <path d="M11 55H32L61 5L89 55H62" />
    </svg>
  </span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  size: {
    type: Number,
    default: 36,
  },
});

const LOGO_SCALE = 0.6;
const LOGO_ASPECT = 67 / 100;

const sizeStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  borderRadius: `${Math.round(props.size * 0.28)}px`,
}));
const logoWidth = computed(() => Math.round(props.size * LOGO_SCALE));
const logoHeight = computed(() => Math.round(props.size * LOGO_SCALE * LOGO_ASPECT));
</script>
